<template>
  <div id="goods_num_inventory_enquiry"
       class="goods_num_inventory_enquiry"
       :class="{'overHide': isShow || isLoading}" @scroll="handleScroll()">
    <!--货号库存查询头部-->
    <div class="goods_num_inventory_enquiry_top">
      <div><input type="text" v-model.trim="numOrName" title="货号/品名" placeholder="货号/品名" @keyup.enter="queryData()"></div>
      <div><input type="checkbox" v-model="todayDeliveryChannel" title="是否显示今天提供发货的渠道" id="today_delivery_channel">
        <label for="today_delivery_channel">显示今天提供发货的渠道</label></div>
      <button class="btn_normal w116" @click="queryData()">查询</button>
    </div>

    <!--货号库存查询信息-->
    <div class="goods_num_inventory_enquiry_msg">
      <div class="msg_content" v-for="(item, index) in list" :key="index">
        <!--信息头部-->
        <div class="msg_content_top">
          <div class="msg_content_top_first clear"><img :src="item.MainImgUrl" height="200"
                                                        width="200"/></div>
          <div class="msg_content_top_second clear">
            <div><label>货号：</label><a @click="ctrlBtn('goodDetail', item)" title="货号">{{item.GoodsId}}</a></div>
            <div><label>品牌：</label><span>{{item.BrandName}}</span></div>
            <div><label>码段：</label><span>{{item.SGName}}</span></div>
            <div><label>分类：</label><span>{{item.ClassName}}</span></div>
            <div><label>性别：</label><span>{{item.Gender | gender}}</span></div>
            <div><label>上市季节：</label><span>{{item.MarketSeasoin}}</span></div>
          </div>
          <div class="msg_content_top_third clear">
            <div><label>品名：</label><span>{{item.GoodsName}}</span></div>
          </div>
          <div class="msg_content_top_fourth clear">
            <div><label>零售价：</label><span>{{item.MarketPrice}}</span></div>
          </div>
        </div>

        <!--信息表格-->
        <div class="msg_content_table">
          <table>
            <thead>
            <tr>
              <th>渠道</th>
              <th>
                <div class="first"><b>尺码</b></div>
                <div class="second"><b>颜色</b></div>
              </th>
              <th v-for="(sizeItem, sizeIndex) in item.BaseSizeList" :key="sizeIndex">
                <p class="pt5 pr5 pl5 no_newline">{{sizeItem.Size}}</p>
                <p class="pr5 pl5 no_newline">[{{sizeItem.AmericanSize}}]</p>
                <p class="pb5 pr5 pl5 no_newline">[{{sizeItem.EuropeSize}}]</p>
              </th>
              <th>合计</th>
              <th>配货率</th>
              <th>成本价（折扣）</th>
              <th>？今日发货</th>
              <th>库存更新时间</th>
              <!--<th><p>备注</p></th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="(channelItem, channelIndex) in item.channelList" :key="channelIndex">
              <td>
                <a @click="ctrlBtn('channelDetail', channelItem)" title="渠道">{{channelItem.SupplierCode}}_{{channelItem.channelName}}</a>
              </td>
              <td>{{channelItem.colorName}}</td>
              <td v-for="(inventoryItem, inventoryIndex) in channelItem.inventory"
                  :key="inventoryIndex" :class="{'fcRed': inventoryItem === 0}">{{inventoryItem}}
              </td>
              <td>{{channelItem.sum}}</td>
              <td v-if="channelItem.distributionRate">{{channelItem.distributionRate}}%</td>
              <td v-if="!channelItem.distributionRate">{{channelItem.distributionRate}}</td>
              <td>{{channelItem.costPrice}}</td>
              <td>{{channelItem.isTodayDelivery | istodaydelivery}}</td>
              <td class="no_newline">{{channelItem.stockUpdateTime | time}}</td>
              <!--<td><p class="w200" :class="{'w400': channelItem.remarks}">{{channelItem.remarks}}</p></td>-->
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--分页-->
     <!-- <div v-if="list.length" class="text_right mt20 mb30">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div> -->
    </div>

    <!--弹出框-->
    <goods-num-inventory-enquiry-embed-msg v-if="isShow"
                                           :title="dialogTitle"
                                           :goodMsg="goodMsg"
                                           :scrollLeft="scrollLeft"
                                           :scrollHeight="scrollHeight"
                                           :showType="dialogShowType"
                                           @cancelbtn="getSelectDialogEmbed"></goods-num-inventory-enquiry-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import GoodsNumInventoryEnquiryEmbedMsg from './goods-num-inventory-enquiry-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'goods-num-inventory-enquiry',
    components: {GoodsNumInventoryEnquiryEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        list: [], // 货号库存列表
        numOrName: '', // 货号/品名
        todayDeliveryChannel: false, // 显示今天提供发货的渠道
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        scrollLeft: 0, // 滚动宽度
        scrollHeight: 0, // 滚动高度
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 5, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    mounted() { // 给window添加一个滚动的滚动监听事件
      // console.log(999);
      // window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      // 根据货号/品名 + 是否显示今天提供发货的渠道 查询
      queryData() {
        this.currentPage = 1;
        this.loadPFGoodsPageData1();
      },

      // 货号库存查询
      loadPFGoodsPageData1() {
        this.isLoading = true;
        this.list = [];
        const params = {
          GoodsIdorName: this.numOrName,
          IsTodayShip: this.todayDeliveryChannel,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadPFGoodsPageData1, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;

                for (let i = 0; i < self.list.length; i++) {
                  self.$set(self.list[i], 'channelList', []); // 每个货品有多少渠道的字段
                  self.$set(self.list[i], 'channelColorList', []); // 同一个渠道，同一个颜色的集合

                  // 先判断渠道是否存在 + 库存（颜色+尺码）是否存在 + 尺码（货品最大的尺码数组，即表头）
                  if (res.data.resData.DataList[i].BaseStoreroomList && res.data.resData.DataList[i].StockList && res.data.resData.DataList[i].BaseSizeList) {
                    // 循环渠道有多少个
                    for (let x = 0; x < res.data.resData.DataList[i].BaseStoreroomList.length; x++) {
                      let colorArr = []; // 取出所有颜色

                      // 循环sku（颜色+尺码）有多少
                      for (let y = 0; y < res.data.resData.DataList[i].StockList.length; y++) {
                        // 判断渠道跟库存中是否有货品
                        if (res.data.resData.DataList[i].BaseStoreroomList[x].StoreroomId === res.data.resData.DataList[i].StockList[y].StoreroomId) {
                          colorArr.push({
                            ColorName: res.data.resData.DataList[i].StockList[y].ColorAlias,
                            Size: res.data.resData.DataList[i].StockList[y].Size,
                            Stock: res.data.resData.DataList[i].StockList[y].Stock,
                            SupplierCode: res.data.resData.DataList[i].StockList[y].SupplierCode,
                            StoreroomId: res.data.resData.DataList[i].StockList[y].StoreroomId,
                            StoreroomName: res.data.resData.DataList[i].StockList[y].StoreroomName,
                            distributionRate: res.data.resData.DataList[i].BaseStoreroomList[x].RealSendRate,
                            costPrice: res.data.resData.DataList[i].BaseStoreroomList[x].CostPrice + '(' + res.data.resData.DataList[i].BaseStoreroomList[x].CostDiscount + ')',
                            isTodayDelivery: res.data.resData.DataList[i].BaseStoreroomList[x].IsShipToday,
                            remarks: res.data.resData.DataList[i].BaseStoreroomList[x].remarks,
                            stockUpdateTime: res.data.resData.DataList[i].BaseStoreroomList[x].StockUpdateTime
                          });
                        }
                      }
                      let channelColorArr = []; // 渠道颜色组合
                      let obj = {}; // 判断的对象赋值
                      for (let cc = 0; cc < colorArr.length; cc++) {
                        if (!obj[colorArr[cc].ColorName]) {
                          obj[colorArr[cc].ColorName] = true;
                        } else {
                          channelColorArr.push(colorArr[cc]);
                        }
                      }

                      // let channelColorArr = colorArr; // 渠道颜色组合
                      for (let c = 0; c < colorArr.length; c++) {
                        let sameColor = {};
                        sameColor = {
                          color: colorArr[c].ColorName,
                          SupplierCode: colorArr[c].SupplierCode,
                          channelId: colorArr[c].StoreroomId,
                          channelName: colorArr[c].StoreroomName,
                          sizeInventoryList: [{size: colorArr[c].Size, inventory: colorArr[c].Stock}],
                          distributionRate: colorArr[c].distributionRate,
                          costPrice: colorArr[c].costPrice,
                          isTodayDelivery: colorArr[c].isTodayDelivery,
                          remarks: colorArr[c].remarks,
                          stockUpdateTime: colorArr[c].stockUpdateTime
                        };
                        for (let cc = 0; cc < channelColorArr.length; cc++) {
                          if (colorArr[c].ColorName === channelColorArr[cc].ColorName) {
                          // if ((colorArr[c].ColorName === channelColorArr[cc].ColorName) && (colorArr[c].StoreroomName === channelColorArr[cc].StoreroomName)) {
                            sameColor.sizeInventoryList.push({
                              size: channelColorArr[cc].Size,
                              inventory: channelColorArr[cc].Stock
                            });
                            colorArr.splice(c, 1);
                          }
                        }
                        // console.log(sameColor);
                        self.list[i].channelColorList.push(sameColor);
                      }
                    }
                  }

                  // 同个渠道同个颜色，不同尺码的库存数据
                  for (let x = 0; x < self.list[i].channelColorList.length; x++) {
                    let sizeArr = []; // 尺码库存数组
                    for (let y = 0; y < res.data.resData.DataList[i].BaseSizeList.length; y++) {
                      sizeArr.push(0);
                      for (let z = 0; z < self.list[i].channelColorList[x].sizeInventoryList.length; z++) {
                        if (res.data.resData.DataList[i].BaseSizeList[y].Size === self.list[i].channelColorList[x].sizeInventoryList[z].size) {
                          sizeArr.splice(y, 1, self.list[i].channelColorList[x].sizeInventoryList[z].inventory);
                        }
                      }
                    }
                    let sum = 0; // 尺码货存总计
                    for (let g = 0; g < sizeArr.length; g++) {
                      sum = sizeArr[g] + sum;
                    }
                    self.list[i].channelList.push({
                      SupplierCode: self.list[i].channelColorList[x].SupplierCode, // 渠道id
                      channelId: self.list[i].channelColorList[x].channelId, // 渠道id
                      channelName: self.list[i].channelColorList[x].channelName, // 渠道名
                      colorName: self.list[i].channelColorList[x].color, // 颜色名
                      inventory: sizeArr, // 尺码集
                      sum: sum, // 尺码货存总计/合计
                      distributionRate: self.list[i].channelColorList[x].distributionRate, // 配货率
                      costPrice: self.list[i].channelColorList[x].costPrice, // 成本价
                      isTodayDelivery: self.list[i].channelColorList[x].isTodayDelivery, // 是否今日发货
                      remarks: self.list[i].channelColorList[x].remarks,
                      stockUpdateTime: self.list[i].channelColorList[x].stockUpdateTime
                    });
                  }
                }

                console.log(self.list);
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, goodMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.goodMsg = goodMsg;
        if (type === 'goodDetail') {
          this.dialogTitle = '货品详情';
        } else {
          this.dialogTitle = '渠道详情';
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadPFGoodsPageData1();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadPFGoodsPageData1();
      },

      // 监听盒子滚动高度
      handleScroll() {
        this.scrollHeight = document.querySelector('#goods_num_inventory_enquiry').scrollTop;
        this.scrollLeft = document.querySelector('#goods_num_inventory_enquiry').scrollLeft;
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    destroyed() { // 离开该页面需要移除这个监听的事件
      // console.log(888);
      // window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
      // this.loadPFGoodsPageData1();
    },
    activated() { // 只有keep-alive激活才会被使用
      this.handleScroll();
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.list = [];
        this.numOrName = '';
        this.todayDeliveryChannel = false;
        this.isShow = false;
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .goods_num_inventory_enquiry {
    overflow: auto;

    &.overHide {
      overflow: hidden;
    }

    .goods_num_inventory_enquiry_top {
      & > div {
        width: 19%;
      }
    }

    .goods_num_inventory_enquiry_msg {
      padding: 0 5px;

      .msg_content {
        width: min-content;
        border: 1px solid $bgC;
        margin-bottom: 20px;

        .msg_content_top {
          margin: 10px 5px;
          width: 100%;
          min-width: 680px;
          height: 200px;

          & > div {
            display: inline-block;
            height: 200px;
            float: left;

            &.msg_content_top_second, &.msg_content_top_third, &.msg_content_top_fourth {
              & > div {
                margin: 0 10px 10px;
              }
            }

            &.msg_content_top_third, &.msg_content_top_fourth {
              height: fit-content;
            }

            label, span {
              display: inline-block;
              font-weight: bolder;
            }

            label {
              width: 70px;
              text-align: right;
            }

            span {
              text-align: left;
            }
          }
        }

        .msg_content_table {
          table {
            margin: 0 10px 20px;

            th, td {
              border: 1px solid $bgC;

              &.fcRed {
                color: #ff0000;
              }
            }

            th {
              white-space: nowrap;
              padding: 0 8px;
              font-weight: normal;

              &:nth-child(2) { /* 第二个表头斜线 */
                padding: 0;

                min-width: 106px;
                height: 43px;
                background-color: $bgC;
                position: relative;

                .first, .second {
                  position: absolute;
                  width: 0;
                  height: 0;

                  b {
                    font-style: normal;
                    font-weight: normal;
                    position: absolute;
                  }
                }

                .first {
                  position: absolute;
                  top: 0;
                  right: 0;
                  border-top: 57px solid #fff;
                  border-left: 105px solid transparent;

                  b {
                    top: -45px;
                    left: -35px;
                  }
                }

                .second {
                  position: absolute;
                  bottom: 0;
                  border-top: 57px solid transparent;
                  border-left: 105px solid #fff;

                  b {
                    top: -25px;
                    left: -95px;
                  }
                }
              }
            }

            td {
              &:nth-child(1) {
                white-space: nowrap;
              }
            }
          }
        }
      }
    }

    a {
      margin-right: 10px;
      color: $calink;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/goods-num-inventory-enquiry.vue